import { contentTypes } from '../_constants'
import { BrowserDetect } from '../_helpers/utils'

const initialState = {
    page: {},
    menu: [],
    ie: BrowserDetect() === 'Explorer',
    menuOpen: false,
    notFound: false,
    eventMessage: '',
    eventError: '',
    footerMessage: '',
    footerError: '',
    gallery: [],
    testimonials: [],
}

export function content(state = initialState, action) {
    switch (action.type) {
        case contentTypes.PAGE_DATA_SUCCESS:
            return {
                ...state,
                page: action.payload,
                notFound: false,
            }
        case contentTypes.PAGE_DATA_FAILURE:
            return {
                ...state,
                notFound: true,
            }
        case contentTypes.MENU_LINKS_SUCCESS:
            return {
                ...state,
                menuLinks: action.payload,
            }
        case contentTypes.FOOTER_FORM_SUCCESS:
            return {
                ...state,
                footerMessage: action.payload,
                footerError: '',
            }
        case contentTypes.FOOTER_FORM_FAILURE:
            return {
                ...state,
                footerMessage: '',
                footerError: action.payload,
            }
        case contentTypes.EVENT_FORM_SUCCESS:
            return {
                ...state,
                eventMessage: action.payload,
                eventError: '',
            }
        case contentTypes.EVENT_FORM_FAILURE:
            return {
                ...state,
                eventMessage: '',
                eventError: action.payload,
            }
        case contentTypes.TOGGLE_MENU:
            return {
                ...state,
                menuOpen: action.payload,
            }
        case contentTypes.MENU_DATA_SUCCESS:
            return {
                ...state,
                menu: action.payload,
            }
        case contentTypes.TESTIMONIAL_LIST_SUCCESS:
            return {
                ...state,
                testimonials: action.payload,
            }
        default:
            return state
    }
}
